<template>
  <div class="content_page" :class="[$store.state.isMirroring && 'mirror_box']">
    <Tabbar :title="$t('withdrawAccount.bindThirdPartyTitle', ['IMPS'])"></Tabbar>
    <Tip :content="$t('withdrawAccount.bindNote')"></Tip>
    <div class="content_area">
      <div class="content_item content_item_space" :class="[$store.state.isMirroring && 'mirror']">
        <div class="content_item_title required" :class="[$store.state.isMirroring && 'mirror']">
          {{ $t('account.account') }}
        </div>
        <input class="content_item_input" type="text" placeholder="" v-model="bankAccount" />
      </div>
      <div class="content_item content_item_space" :class="[$store.state.isMirroring && 'mirror']">
        <div class="content_item_title required" :class="[$store.state.isMirroring && 'mirror']">
          {{ $t('withdrawAccount.accountName') }}
        </div>
        <input class="content_item_input" type="text" placeholder="" v-model="bankAccountName" />
      </div>
      <div class="content_item content_item_space" :class="[$store.state.isMirroring && 'mirror']">
        <div class="content_item_title required" :class="[$store.state.isMirroring && 'mirror']">
          {{ $t('common.phone') }}
        </div>
        <input
          class="content_item_input"
          type="text"
          :disabled="!!$store.state.userInfo.phone"
          placeholder=""
          v-model="phone"
          style="direction: ltr"
        />
      </div>
      <div class="content_item content_item_space" :class="[$store.state.isMirroring && 'mirror']">
        <div class="content_item_title required" :class="[$store.state.isMirroring && 'mirror']">
          {{ $t('common.email') }}
        </div>
        <input
          class="content_item_input"
          type="text"
          :disabled="!!$store.state.userInfo.email"
          placeholder=""
          v-model="email"
          style="direction: ltr"
        />
      </div>
      <div class="content_item content_item_space" :class="[$store.state.isMirroring && 'mirror']">
        <div class="content_item_title required" :class="[$store.state.isMirroring && 'mirror']">
          {{ $t('withdrawAccount.ifscCode') }}
        </div>
        <input class="content_item_input" type="text" maxlength="11" placeholder="" v-model="bankSwift" />
      </div>
      <CommonBtn class="next_btn" :text="$t('common.done')" :on-click="bindThirdPartyPay" />
      <CommonBtn class="next_btn delete" :text="$t('common.delete')" :on-click="unbind" />
    </div>
    <PopWindow v-show="popShow" :content="popContent" :btn="popBtn" @closePop="closePop"></PopWindow>
    <CheckPayPassword :show="showKeyboard" v-bind:on-success="onPasswordSuccess" v-bind:on-close="onClose" />
  </div>
</template>

<script>
import Tabbar from '@/components/Tabbar.vue'
import { Toast } from 'vant'
import PopWindow from '@/components/PopWindow'
import CommonBtn from '@/components/CommonBtn'
import CheckPayPassword from '@/components/CheckPayPassword'
import linkMixins from '@/mixins/linkMixins'
import Tip from '@/components/LinkAccount/Tip.vue'

export default {
  name: 'BindNewIMPS',
  mixins: [linkMixins],
  data() {
    return {
      channel: '',
      withdrawType: undefined,
      isShow: false,
      bankAccount: '',
      bankAccountName: '',
      phone: '',
      email: '',
      bankSwift: '',
      popShow: false,
      popContent: '',
      popBtn: '',
      bankType: '',
      withdrawId: ''
    }
  },
  components: {
    Tabbar,
    PopWindow,
    CommonBtn,
    CheckPayPassword,
    Tip
  },
  mounted() {
    this.withdrawId = this.$route.params.withdrawId
    this.oldAccount = this.$route.params.account
    this.bankAccount = this.$route.params.account
    this.channel = 'IMPS'
    this.withdrawType = 16
    this.phone = this.$store.state.userInfo.phone
    this.email = this.$store.state.userInfo.email
    this.getUserIMPSDetail()
  },
  methods: {
    closePop() {
      this.popShow = false
    },
    bindThirdPartyPay() {
      if (!this.bankAccount) {
        Toast(this.$t('withdrawAccount.accountEmptyToast'))
        return
      }
      if (!this.bankAccountName) {
        Toast(this.$t('withdrawAccount.accountNameEmptyToast'))
        return
      }
      if (!this.phone) {
        Toast(this.$t('withdrawAccount.phoneEmptyToast'))
        return
      }
      if (!this.email) {
        Toast(this.$t('withdrawAccount.emailEmptyToast'))
        return
      }
      if (!this.bankSwift) {
        Toast(this.$t('withdrawAccount.ifscCodeEmptyToast'))
        return
      }
      if (this.bankSwift.length !== 11) {
        Toast(this.$t('withdrawAccount.ifscCodeLengthToast'))
        return
      }
      const data = {
        oldAccount: this.oldAccount,
        bankAccount: this.bankAccount,
        bankAccountName: this.bankAccountName,
        phone: this.phone,
        email: this.email,
        bankSwift: this.bankSwift,
        withdrawType: this.withdrawType,
        bankType: this.bankType,
        withdrawId: this.withdrawId
      }
      this.$http
        .post(window.serverPath + '/api/account/EditUserBankCard', data)
        .then((res) => {
          if (res.data && res.data.code === '200') {
            if (this.$route.query.hasOwnProperty('redirect')) {
              this.$router.replace({ name: this.$route.query.redirect })
            } else {
              this.$router.back()
            }
          } else if (res.data.code === '60402') {
            Toast(this.$t('withdrawAccount.bindIMPSRepeatToast'))
          } else if (res.data.code === '40208') {
            // 该银行卡已与其他姓名绑定
            this.popShow = true
            this.popContent = res.data.message
            this.popBtn = 'OK'
          } else {
            Toast(this.$t('basicLevel.failToast'))
          }
        })
        .catch((err) => console.log(err))
    },
    getUserIMPSDetail() {
      if (!this.bankAccount) {
        console.log('空账号')
        return
      }
      const data = {
        bankAccount: this.bankAccount,
        userId: this.$store.state.userInfo.userId
      }
      this.$http
        .post(window.serverPath + '/api/account/UserBankCardDetail', data)
        .then((res) => {
          if (res.data && res.data.code === '200') {
            this.bankSwift = res.data.data.bankSwift
            this.bankAccountName = res.data.data.bankAccountName
            this.bankType = res.data.data.bankType
          } else {
            Toast({ message: this.$t('withdrawAccount.queryFailedToast') })
          }
        })
        .catch((err) => console.log(err))
    }
  }
}
</script>

<style scoped>
.content_page {
  width: 100%;
  background-color: #fff;
  position: relative;
  height: 100%;
  padding: 0 0.16rem;
}

.content_area {
  width: 100%;
  box-sizing: border-box;
}

.content_item {
  width: 100%;
  height: 0.6rem;
  border-bottom: 1px solid #efefef;
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;

  &.mirror {
    justify-content: right;
  }
}

.content_item_usdt {
  width: 200%;
  height: 0.6rem;
  border-bottom: 1px solid #eeeef7;
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
}

.content_item_space {
  justify-content: space-between;
}

input {
  background: none;
  outline: none;
  border: none;
  margin: 0;
  height: 0.4rem;
  width: calc(100% - 1.2rem);
  font-size: 0.14rem;
}

textarea {
  background: none;
  outline: none;
  border: none;
  margin: 0;
  height: 0.8rem;
  width: calc(100% - 1.2rem);
  font-size: 0.16rem;
  resize: none;
}

input:focus,
textarea:focus {
  border: none;
}

input::-webkit-input-placeholder,
textarea::-webkit-input-placeholder {
  color: #aeaeae;
  font-size: 0.14rem;
}

input:disabled {
  color: #828282;
}

.content_item_title {
  color: #2f2f2f;
  width: 1.2rem;
  text-align: left;
  font-weight: bold;
  font-size: 0.14rem;

  &.mirror {
    text-align: right;
  }
}
.content_item_title_usdt {
  font-size: 0.16rem;
  color: #282828;
  width: 2.2rem;
  text-align: left;
  font-weight: bold;

  &.mirror {
    text-align: right;
  }
}

.content_item_title.required::before {
  content: '*';
  color: red;
  margin-inline-end: 0.03rem;
  position: relative;
  top: 0.02rem;
}

.content_item_input {
  text-align: right;
}

.mirror_box .content_item_input {
  text-align: left;
}

.select_account {
  flex: auto;
  color: #252525;
  font-size: 0.16rem;
  text-align: left;
}

.select_account_arrow {
  flex: none;
  box-sizing: border-box;
  padding: 5px;
}

.select_account_arrow_img {
  width: 0.12rem;
  height: 0.12rem;
}

.content_code_input {
  color: #252525;
  font-size: 0.16rem;
  width: 100%;
}

.send_code_btn {
  color: #378e5b;
  font-size: 0.14rem;
}

.done_btn_area {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 0.86rem;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-top: 1px solid #efefef;
  padding: 0.18rem;
  background: #ffffff;
}

.disable_btn {
  background-color: #dedef0;
}

/* new */
.next_btn {
  margin-top: 0.16rem;
  width: 100% !important;
  font-size: 0.16rem !important;
}

.next_btn.delete {
  background: #fff;
  color: #3fbb70;
  border: 0.01rem solid #3fbb70;
}
</style>



// WEBPACK FOOTER //
// src/views/EditNewIMPS.vue